export default "//static.tradera.net/touchweb/static/output/images/push-selling-icon.33e7a17c.svg";